<template>
	<div class="qw-autocomplete-root qw-special qw-input-root qw-input input-background"
		v-bind="attrsStylesClass">
		<el-autocomplete
			ref="autocompleteRef"
			v-bind="$attrs"
		>

			<template v-if="$slots.header" #header>
				<slot name="header"></slot>
			</template>

			<template #append>
				<slot name="append"></slot>
			</template>

			<template #default="{ item }">
				<slot name="default" :item="item"></slot>
			</template>

			<template v-if="$slots.footer" #footer>
				<slot name="footer"></slot>
			</template>

		</el-autocomplete>

	</div>
</template>

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwAutocomplete",
	components: {},
	extends: BaseComponent,
	inheritAttrs: false,

	methods: {
		focus() {
			this.refsAutocomplete.inputRef.focus()
		},
	},

	computed: {
		refsAutocomplete() {
			return this.$refs.autocompleteRef.$refs
		}
	},
}
</script>
